<template>
  <v-form ref="form" v-model="valid" @submit.prevent="submitHandler">
    <v-row align="start" dense>
      <v-col cols="9" sm="9">
        <v-autocomplete
          filled
          dense
          class="no-before"
          hide-details="auto"
          :items="getProducts"
          item-text="nom"
          item-value="id"
          v-model="item.pk_recette_produit"
          :rules="[v => !!v || 'Un ingrédient est requis']"
          label="Ingrédient à ajouter"
          autocomplete="off"
          readonly
          background-color="rgba(0, 0, 0, 0.02)"
        >
          <template v-slot:item="data">
            <v-list-item-action v-if="!data.item.data">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="error" small>
                    fa-exclamation-triangle
                  </v-icon>
                </template>
                <span>Ingrédient non configuré</span>
              </v-tooltip>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title v-html="data.item.nom"></v-list-item-title>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="3" sm="3">
        <v-text-field
          hide-details="auto"
          filled
          dense
          class="no-before"
          v-model="item.ordre"
          label="Ordre"
          :suffix="''"
          type="number"
          min="0"
          step="0.1"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row align="center" dense>
      <v-col cols="12" sm="6">
        <j-decimal-input
          :hide-details="true"
          filled
          dense
          class="no-before"
          v-model="item.quantite"
          label="Quantité"
          :suffix="''"
          :required="true"
          :min="0.0001"
          :decimal="4"
          auto-hide-details
        ></j-decimal-input>
      </v-col>
      <v-col cols="12" sm="6">
        <v-select
          hide-details="auto"
          filled
          dense
          class="no-before"
          label="Unité"
          v-model="item.unite_mesure"
          :items="getPossibleUnitSelectionForProduct"
          :rules="[v => !!v || 'Une unité de mesure est requise']"
        ></v-select>
      </v-col>
    </v-row>
    <v-row align="center" no-gutters dense>
      <v-btn
        text
        x-small
        @click="item.is_inventory_link = !item.is_inventory_link"
        :color="item.is_inventory_link ? 'success' : ''"
      >
        <v-icon x-small left>fa-link</v-icon>
        Lier les commandes de cet ingrédient à la recette
      </v-btn>
    </v-row>
    <v-row align="center" justify="space-between" class="mt-2" no-gutters dense>
      <v-btn small icon color="error" @click="deleteIngredient">
        <v-icon small>fa-trash</v-icon>
      </v-btn>
      <RecipeDialogEditor
        v-if="getIsIntermediate === true && getRecipeId(item) !== null"
        :id="getRecipeId(item)"
        :recipe-id="recipeId"
        :open-editors.sync="openEditors"
      >
      </RecipeDialogEditor>
      <ProductDialogEditor
        v-else
        :id="item.pk_recette_produit"
        :recipe-id="recipeId"
        :open-editors.sync="openEditors"
      ></ProductDialogEditor>
      <v-btn color="success" type="submit">
        <v-icon left small>
          fa-check
        </v-icon>
        Ok
      </v-btn>
    </v-row>
  </v-form>
</template>

<script>
import { mapGetters } from "vuex";
import { productMixin } from "@/mixins";
import ProductDialogEditor from "./ProductDialogEditor";
import RecipeDialogEditor from "./RecipeDialogEditor";
export default {
  name: "IngredientEditor",
  components: {
    ProductDialogEditor,
    RecipeDialogEditor
  },
  mixins: [productMixin],
  props: {
    recipeId: {
      required: true
    },
    item: {
      required: true
    },
    intermediateProduct: {
      default: null
    },
    openEditors: {
      default: () => []
    }
  },
  computed: {
    ...mapGetters([
      "getRecipes",
      "getProducts",
      "getOrganisationId",
      "getAllowedUnits",
      "getCustomUnits",
      "getCustomUnitsValues"
    ]),
    getPossibleUnitSelectionForProduct() {
      const product = this.getProducts.find(
        x => x.id === this.item.pk_recette_produit
      );
      try {
        return this.getProductUnitPossibilities(product);
      } catch {
        return [];
      }
    },
    getIsIntermediate() {
      const product = this.getProducts.find(
        x => x.id === this.item.pk_recette_produit
      );
      if (product) {
        return product.est_intermediaire;
      } else {
        return false;
      }
    }
  },
  data() {
    return {
      valid: false
    };
  },
  methods: {
    submitHandler() {
      if (this.valid) {
        this.$emit("submit");
      }
    },
    deleteIngredient() {
      this.item.is_deleted = true;
      this.$emit("submit");
    },
    getRecipeId(item) {
      const recipe = this.getRecipes.find(
        x => x.fk_produit_intermediaire === item.pk_recette_produit
      );
      if (recipe) {
        return recipe.id;
      } else {
        return null;
      }
    }
  }
};
</script>

<style></style>
